import { GenericAssets } from "../../../generic-sprites/GenericAssets"
import { CameraZoom, ZoomTarget } from "../../../utils/CameraZoom"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { Videos } from "../../../utils/Videos"
import { everyCigMovieName } from "../EveryCigAssets"
import { EveryCigBodyPart } from "../EveryCigTypes"

export class EveryCigMovieContainer {
    static playCigVideo = async (
        game: Phaser.Game,
        part: EveryCigBodyPart,
        onComplete?: () => void,
        zoomTarget?: ZoomTarget,
    ) => {
        CameraZoom.resetZoom(game)
        const blackBackground = Sprites.add(game, GenericAssets.BLACK_PIXEL)
        blackBackground.width = Scale.cachedValues.screenWidth
        blackBackground.height = Scale.cachedValues.screenHeight

        function doOnComplete() {
            if (video) {
                video.destroy()
            }
            if (onComplete) {
                onComplete()
            }
            blackBackground.destroy()
            if (zoomTarget) {
                CameraZoom.instaZoom(
                    CameraZoom.createZoomInfo(game, zoomTarget),
                )
            }
        }

        const video = await Videos.add(game, everyCigMovieName(part), {
            volume: 0.7,
            onComplete: () => {
                doOnComplete()
            },
            onException: () => {
                doOnComplete()
            },
            fillScreen: true,
            centerVertically: true,
        })
    }
}
